import { CatalogueService } from "./KaimanServices/catalogue.service";
import { GeographicLocationService } from './KaimanServices/GeographicLocation.service';
import { KaimanService } from "./KaimanServices/kaiman.service";
import { TagsService } from "./KaimanServices/Tags.service";
import { useApiClient } from "../api/apiClient";
import { KillbillService } from "./KaimanServices/Killbill.service";


const useKaimanService = () => {
    const api = useApiClient();
    return new KaimanService(api);
};

const useCatalogueService = () => {
    const api = useApiClient();
    return new CatalogueService(api);
};
const useTagsService = () => {
    const api = useApiClient();
    return new TagsService(api);
};
const useGeographicLocationService = () => {
    const api = useApiClient();
    return new GeographicLocationService(api);
};
const useKillbillService = () => {
    const api = useApiClient();
    return new KillbillService(api);
};


export {
    useKaimanService,
    useCatalogueService,
    useTagsService,
    useGeographicLocationService,
    useKillbillService
}